import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

	addToCartFromQuickOrderToast: boolean = false;

	constructor(
		public toastService: ToastService
	) { }

	ngOnInit() {
	}

	/** 
	 * start:  quick order page for add multiple items to cart
	 */
	mixMaxToast(){
		if(this.addToCartFromQuickOrderToast){
			this.addToCartFromQuickOrderToast = false;
		}
		else {
			this.addToCartFromQuickOrderToast = true;
		}
	}

	/** 
	 * end: quick order page for add multiple items to cart
	 */
}
